import { render, staticRenderFns } from "./CustomSelectCurrency.vue?vue&type=template&id=4cfb1d19&scoped=true&"
import script from "./CustomSelectCurrency.vue?vue&type=script&lang=js&"
export * from "./CustomSelectCurrency.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectCurrency.vue?vue&type=style&index=0&id=4cfb1d19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb1d19",
  null
  
)

export default component.exports